<template>
  <div>
    <el-form :inline="true">
      <el-form-item>
        <el-input v-model="searchKeyword" placeholder="请输入车辆或日期" style="margin-bottom: 10px;"></el-input>
      </el-form-item>
      <!-- 新增: 搜索按钮 -->
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-form-item>
      <!-- 新增: 导出按钮 -->
      <el-form-item>
        <el-button type="success" @click="handleExport">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="filteredTableData" style="width: 100%">
      <el-table-column prop="vehicle" label="车辆" width="180">
        <template #default="scope">
          {{ scope.row.vehicle }}
        </template>
      </el-table-column>
      <el-table-column prop="date" label="日期" width="180">
        <template #default="scope">
          {{ scope.row.date }}
        </template>
      </el-table-column>
      <el-table-column prop="airConditioningRuntime" label="空调运行时长" width="180">
        <template #default="scope">
          {{ scope.row.airConditioningRuntime }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchKeyword: '', // 新增: 用于存储搜索关键字
      tableData: [
        { vehicle: '434', date: '2023-04-20', airConditioningRuntime: '5h10m43s' },
        { vehicle: '433', date: '2023-04-20', airConditioningRuntime: '6h56m34s' },
        { vehicle: '436', date: '2023-04-20', airConditioningRuntime: '3h46m47s' },
        { vehicle: '429', date: '2023-04-20', airConditioningRuntime: '6h57m23s' },
        { vehicle: '431', date: '2023-04-20', airConditioningRuntime: '11h57m0s' },
        { vehicle: '418', date: '2023-04-20', airConditioningRuntime: '3h35m0s' },
        { vehicle: '408', date: '2023-04-20', airConditioningRuntime: '3h23m40s' },
        { vehicle: '419', date: '2023-04-20', airConditioningRuntime: '4h56m40s' },
        { vehicle: '406', date: '2023-04-20', airConditioningRuntime: '3h59m48s' },
        { vehicle: '405', date: '2023-04-20', airConditioningRuntime: '0h55m0s' }
      ]
    };
  },
  computed: {
    filteredTableData() { // 新增: 根据搜索关键字过滤表格数据
      return this.tableData.filter(data => {
        return data.vehicle.toLowerCase().includes(this.searchKeyword.toLowerCase()) ||
               data.date.toLowerCase().includes(this.searchKeyword.toLowerCase());
      });
    }
  },
  methods: {
    // 新增: 搜索方法
    handleSearch() {
      // 实现搜索逻辑
      console.log('搜索关键字:', this.searchKeyword);
    },
    // 新增: 导出方法
    handleExport() {
      // 实现导出逻辑
      console.log('导出数据:', this.filteredTableData);
    }
  }
};
</script>